import * as React from 'react';
import classNames from 'classnames';

import styles from './text-field.module.css';

type TextFieldUiProps = {
  id: string,
  value: string,
  rows?: number,
  labelText?: string,
  className?: string,
  placeholder?: string,
  counter?: number,
  error?: string | boolean | undefined,
  disabled?: boolean,
  minLength?: number,
  maxLength?: number,
  onChange: (val: string) => void
};

function TextFieldUi(props: TextFieldUiProps) {
  const {
    id,
    value,
    rows,
    labelText,
    placeholder,
    error,
    counter,
    className,
    disabled,
    minLength,
    maxLength,
    onChange,
  } = props;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const rawValue = e.target.value;
    // Replace multiple consecutive spaces with single space
    const cleanedValue = rawValue.replace(/\s+/g, ' ');
    onChange(cleanedValue);
  };

  // Calculate trimmed length for validation
  const trimmedValue = value.trim();
  const trimmedLength = trimmedValue.length;

  return (
    <div className={styles.layout}>
      <label htmlFor={id} className={styles.label}>
        {labelText}
      </label>
      <textarea
        id={id}
        name={id}
        value={value}
        rows={rows}
        onChange={handleChange}
        className={`${styles.textarea} ${className} ${error ? styles.textareaError : ''}`}
        placeholder={placeholder}
        disabled={disabled}
        maxLength={maxLength}
      />
      <div className={classNames({
        [styles.counter]: true,
        [styles.acceptedLength]: minLength !== undefined && trimmedLength >= minLength,
      })}
      >
        {counter ?? trimmedLength}/{maxLength} {minLength && `(minimum ${minLength})`}
      </div>
      {error && <div className={styles.error}>{error}</div>}
    </div>
  );
};

TextFieldUi.defaultProps = {
  className: '',
  placeholder: '',
  labelText: '',
  rows: 3,
  error: false,
  disabled: false,
  minLength: undefined,
  maxLength: undefined,
};

export default TextFieldUi;
